import { Injectable, inject, signal } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { NavigationEnd, NavigationStart, Router } from "@angular/router";
import { addQueryParams } from "src/standard/services/addQueryParams";
import { getQueryParams } from "src/standard/services/getQueryParams";

function getIsStandaloneUrl(queryParams: Record<string, string>) {
  const standaloneQueryParam = queryParams.standalone?.toLowerCase();
  if (standaloneQueryParam === "true") {
    return true;
  }

  return false;
}

@Injectable({
  providedIn: "root",
})
export class StandalonePageService {
  private router = inject(Router);

  constructor() {
    this.router.events.pipe(takeUntilDestroyed()).subscribe((event): void => {
      const standalone = this.standalone();
      const queryParams = getQueryParams();

      if (event instanceof NavigationStart) {
        if (typeof standalone === "boolean") {
          // already initialized, no switching via URL
          return;
        }

        const isStandaloneUrl = getIsStandaloneUrl(queryParams);
        if (isStandaloneUrl) {
          this.standalone.set(true);

          // Update the shell-related CSS variables
          // --bs-h-header and --bs-h-footer
          const el = document.documentElement;
          el.style.setProperty("--bs-h-shell-header", "0px");
          el.style.setProperty("--bs-h-shell-footer", "0px");
        } else {
          this.standalone.set(false);
        }
      } else if (event instanceof NavigationEnd) {
        if (standalone) {
          addQueryParams({ standalone: true });
        }
      }
    });
  }

  readonly standalone = signal<boolean | undefined>(undefined);
}
